import {CatalogReference} from '@wix/auto_sdk_ecom_current-cart';
import {CatalogReferenceModel} from './CatalogReference.model';

export class SourceModel {
  public catalogReference: CatalogReferenceModel;

  constructor(params: SourceModel) {
    this.catalogReference = params.catalogReference;
  }

  public static fromCartV1(catalogReference: CatalogReference) {
    return new SourceModel({
      catalogReference: CatalogReferenceModel.fromCartV1(catalogReference),
    });
  }
}
